module.exports = __webpack_public_path__ + "img/parallaxsample.cf3b40a6.jpg";